import { supportTicketKeys } from './keys';
import { apiRequest } from '@glow/shared/lib/http';
import { useInvalidatingMutation } from '@glow/shared/lib/vueQuery';

export type SupportTicketCreateRequest = {
  subject: string;
  text: string;
};

export function addSupportTicket(request: SupportTicketCreateRequest) {
  return apiRequest('post', '/support-tickets', request);
}

export function useAddSupportTicket() {
  return useInvalidatingMutation(
    supportTicketKeys.all,
    (request: SupportTicketCreateRequest) => addSupportTicket(request)
  );
}
